import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {CouponService_GetHighTierCouponBannerLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useTargetGroupIdentifier} from '../../shared-deprecated/useTargetGroupIdentifier';
import {useReductionsStateRequestParameter} from '../ReductionsState/useReductionsStateRequestParameter';

export const useHighTierCoupon = () => {
  const targetGroupIdentifier = useTargetGroupIdentifier();

  const {isActive} = useIsFeatureActive('high_tier_coupons');

  const session = useFullSession();

  return useGrpcRequest(
    CouponService_GetHighTierCouponBannerLazy,
    {
      reductionsState: useReductionsStateRequestParameter(),
      session: session!,
      targetGroup: targetGroupIdentifier,
    },
    {
      disabled: !isActive || !session,
    },
  );
};
